var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React, { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { connect } from '../../store/connect';
import { getPaymentManager } from "../../models/PaymentModel/PaymentModelManager";
import { getResponseManager } from "../../responseManager/BeeResponseManager";
import parse from "html-react-parser";
import { ReactiveForm } from "../Form";
import { componentMapper, validatorMapper, componentTypes } from "../Form/form-constants";
import { setAppState, setPaymentSessionId } from "../../store/actions";
import { getInitialData, getPaybookData, getPaybookSession, getPaybookEntities, postPaybookForm, useRedirectLoader } from "../../store/actions/response.actions";
import pick from "lodash/pick";
import { APP_STATE } from "../../store/store";
import { getHashOrPath, redirectToPage } from "../../helpers";
import { ERoute } from "../../helpers/Routes";
import { API_METHODS_ENUM } from "../../httpService";
import { LoaderState } from "../../store/actions/loader.actions";
import { OverlayLoader } from "../Loader/OverlayLoader";
import filter from "lodash/filter";
import noop from "lodash/noop";
import styled from "styled-components";
import { Flex } from "../Flex";
import { FORM_BUTTONS } from "../../classConstants";
var StyledFlex = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-top: var(--ws-coupon-code-margin, 2em);\n\n    gap: 1em;\n    align-items: flex-end !important;\n    justify-content: space-between;\n\n    .", " {\n        margin-left: auto;\n    }\n"], ["\n    margin-top: var(--ws-coupon-code-margin, 2em);\n\n    gap: 1em;\n    align-items: flex-end !important;\n    justify-content: space-between;\n\n    .", " {\n        margin-left: auto;\n    }\n"])), FORM_BUTTONS);
var paybookFactory = function () {
    var Paybook = function (props) {
        var t = useTranslation().t;
        var _a = useRedirectLoader(API_METHODS_ENUM.POST_PAYBOOK_FORM), showRedirectLoader = _a[0], setShowRedirectLoader = _a[1];
        var paymentGateway = props.paymentGateway, bills = props.bills, couponCode = props.couponCode, setAppState = props.setAppState, setPaymentSessionId = props.setPaymentSessionId, getPaybookEntities = props.getPaybookEntities, postPaybookForm = props.postPaybookForm, form = props.form, is_gross_tax = props.is_gross_tax;
        var _b = useState(form || {}), mergedForm = _b[0], setMergedForm = _b[1];
        var paymentSessionId = form.payment_session_id;
        var formButtons = useMemo(function () { return ({
            component: componentTypes.FORM_BUTTONS,
            onCancel: function () { return redirectToPage(getHashOrPath(props.paybookReferencePage)); },
            onSubmit: noop,
            backLabel: t("paybook.back"),
            submitLabel: t("paybook.submit"),
            name: "form-buttons"
        }); }, [props.paybookReferencePage]);
        useEffect(function () {
            setAppState(APP_STATE.PAYBOOK);
            setShowRedirectLoader(false);
            if (paymentSessionId) {
                setPaymentSessionId(paymentSessionId);
                getPaybookEntities(paymentSessionId);
            }
        }, [paymentSessionId]);
        useEffect(function () {
            setMergedForm(form);
        }, [JSON.stringify(form)]);
        var getTitle = function () {
            var translationKey = is_gross_tax ? "paybook.pageDescription" : "paybook.pageDescriptionNet";
            var tax = props.tax, total = props.total, totalNet = props.totalNet, selectedTax = props.selectedTax, selectedTotal = props.selectedTotal, selectedTotalNet = props.selectedTotalNet;
            return parse(t(translationKey, {
                tax: tax,
                total: total,
                totalNet: totalNet,
                selectedTax: selectedTax,
                selectedTotal: selectedTotal,
                selectedTotalNet: selectedTotalNet
            }));
        };
        var onFormSubmit = function () {
            var request = pick(form, "payment_method", "payment_session_id", "selected_bill_ids");
            postPaybookForm(__assign(__assign({}, request), { selected_bill_ids: filter(form.selected_bill_ids, "selected").map(function (_a) {
                    var id = _a.id;
                    return id;
                }) }));
        };
        if (!form.payment_session_id) {
            redirectToPage(getHashOrPath(ERoute.BOOKCART));
            return null;
        }
        if (!bills.length && !paymentGateway)
            return null;
        var fields = __spreadArray(__spreadArray([], bills), [
            paymentGateway,
            {
                name: "coupon-and-buttons",
                as: StyledFlex,
                component: componentTypes.BASIC,
                fields: [
                    couponCode,
                    formButtons
                ]
            }
        ]).filter(Boolean);
        return (React.createElement(React.Fragment, null,
            getTitle(),
            React.createElement(ReactiveForm, { name: "payment-form", schema: { fields: fields }, componentMapper: componentMapper, validatorMapper: validatorMapper, initialValues: mergedForm, onSubmit: onFormSubmit }),
            React.createElement(OverlayLoader, { show: showRedirectLoader })));
    };
    var mapStateToProps = function (state) {
        var _a = state.appReducer, paymentSessionId = _a.payment_session_id, paybookReferencePage = _a.paybookReferencePage;
        var initialData = getInitialData(state.responseReducer).response;
        var _b = getPaybookSession(state.responseReducer).response, bookingData = _b === void 0 ? null : _b;
        var _c = getPaybookData(state.responseReducer).response, paymentFormResponse = _c === void 0 ? null : _c;
        var forms = state.formReducer.forms;
        return {
            paymentSessionId: paymentSessionId,
            paybookReferencePage: paybookReferencePage,
            paymentFormResponse: paymentFormResponse,
            form: forms["payment-form"] || {},
            bookingData: bookingData,
            initialData: initialData,
            loaderState: state.loaderReducer
        };
    };
    var mergeProps = function (stateProps, dispatchProps, ownProps) {
        var paymentFormResponse = stateProps.paymentFormResponse, form = stateProps.form, bookingData = stateProps.bookingData, initialData = stateProps.initialData, paymentSessionId = stateProps.paymentSessionId;
        var payment_session_id = bookingData ? getResponseManager(bookingData).getData() : paymentSessionId;
        var loaderState = new LoaderState(stateProps.loaderState, { keys: [API_METHODS_ENUM.GET_PAYBOOK_ENTITIES] });
        var mergedProps = __assign(__assign(__assign({ form: { payment_session_id: payment_session_id }, paybookReferencePage: stateProps.paybookReferencePage }, dispatchProps), ownProps), { bills: [], paymentGateway: null, is_gross_tax: "", total: 0, tax: 0, totalNet: 0, selectedTotal: 0, selectedTax: 0, selectedTotalNet: 0, isLoading: !bookingData || loaderState.isLoading() });
        if (paymentFormResponse) {
            var options = getResponseManager(initialData).options();
            var rm = getResponseManager(paymentFormResponse);
            var entities = rm.entities();
            if (!entities)
                return mergedProps;
            var pm = getPaymentManager(entities, __assign(__assign({}, options), { discountStatus: rm.discountStatus(), hasError: loaderState.hasErrored() }));
            var derivedForm = pm.deriveForm(form, payment_session_id);
            var _a = pm.getPaymentForm(derivedForm), bills = _a.bills, paymentGateway = _a.paymentGateway, couponCode = _a.couponCode, totals = __rest(_a, ["bills", "paymentGateway", "couponCode"]);
            mergedProps.form = derivedForm;
            mergedProps.bills = bills;
            mergedProps.paymentGateway = paymentGateway;
            mergedProps.couponCode = couponCode;
            mergedProps.is_gross_tax = options === null || options === void 0 ? void 0 : options.is_gross_tax;
            mergedProps.tax = totals.tax;
            mergedProps.total = totals.total;
            mergedProps.totalNet = totals.totalNet;
            mergedProps.selectedTax = totals.selectedTax;
            mergedProps.selectedTotal = totals.selectedTotal;
            mergedProps.selectedTotalNet = totals.selectedTotalNet;
        }
        return mergedProps;
    };
    return connect(mapStateToProps, { setAppState: setAppState, getPaybookEntities: getPaybookEntities, setPaymentSessionId: setPaymentSessionId, postPaybookForm: postPaybookForm }, mergeProps)(Paybook);
};
export var PaybookPage = paybookFactory();
var templateObject_1;
